import PropTypes from 'prop-types';
import React from 'react';

import { LightBulbIcon } from '@heroicons/react/solid';
import noop from 'lodash/noop';

import Modal from 'components/Modal';
import Button from 'components/buttons/Button';

const CompanySnapshotDeleteModal = ({
  open = false,
  title = '',
  onClose = noop,
  onDelete = noop,
}) => (
  <Modal open={open}>
    <Modal.Icon Icon={LightBulbIcon} />
    <Modal.Title>Delete snapshot</Modal.Title>
    <Modal.Description>
      Are you sure you want to delete snapshot: <b>{title}</b>
    </Modal.Description>
    <Modal.RightButtons>
      <Button type="secondary" onClick={onClose}>
        Cancel
      </Button>
      <Button
        onClick={onDelete}
        eventType="pressPage_update"
        eventProperties={{ action: 'milestone_delete' }}
        data-test-id="company-snapshots-deleteModal-delete"
      >
        Delete snapshot
      </Button>
    </Modal.RightButtons>
  </Modal>
);

CompanySnapshotDeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CompanySnapshotDeleteModal;
